import mori from 'mori';

/**
 * Get the active timeframes from the filteredData
 * and then append on 'any'
 * @param  {mori.vector} data [filteredData]
 * @return {mori.vector}      [any active timeframes + `any`]
 */
export default function getTimeframes(data) {
  return mori.conj(mori.reduce(
    (acc, curr) => mori.conj(acc, mori.first(curr)),
    mori.vector(),
    data
  ), 'any');
}



/** WEBPACK FOOTER **
 ** ../~/eslint-loader!./js/services/getFootnotes/getTimeframes.js
 **/